import "./burger.scss";
import { FundViewOutlined, LogoutOutlined, MenuOutlined } from "@ant-design/icons";
import { useAuthContext } from "../services/auth.service";

export const BurgerMenu = ({isBurgerMenuVisible, setIsBurgerMenuVisible}: {isBurgerMenuVisible: boolean, setIsBurgerMenuVisible: (visible: boolean) => void}) => {
    const auth = useAuthContext();
    return (
        <div className="burger-menu">
            <div className="burger-menu__header">
                <div className="burger-menu__header__logo">
                    <img src="/images/logo.png" alt="McLloyd" />
                </div>
                <div className="burger-menu__action">
                    <p className="burger-menu__action__close" onClick={() => setIsBurgerMenuVisible(!isBurgerMenuVisible)}>
                        <MenuOutlined style={{ fontSize: 18 }} />
                    </p>
                </div>
            </div>
            {
                isBurgerMenuVisible && (
                    <div className="burger-menu__container">
                        <div className="burger-menu__menu">
                            <a className='burger-menu__item' href="/">
                                <FundViewOutlined />
                                Calendar
                            </a>
                        </div>
                        <div className="burger-menu__menu">
                            <div className='burger-menu__item' onClick={() => auth.logout()}>
                                <LogoutOutlined />
                                Logout
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};